export default __webpack_public_path__ + "129ca5ddcd655f82f58cbddd347736d7.png";